import { render, staticRenderFns } from "./BrandCategoryFilter.vue?vue&type=template&id=3536c674&scoped=true"
import script from "./BrandCategoryFilter.vue?vue&type=script&lang=js"
export * from "./BrandCategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./BrandCategoryFilter.vue?vue&type=style&index=0&id=3536c674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536c674",
  null
  
)

export default component.exports